
import React from 'react'
import firebaseApp from '../../firebase';
import './styles/FileUpload.scss'

const rootStyle = {
  'display': 'inline-block'
}

class BulkImportUpload extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      'progress': null,
      'done': false
    }
    this.uploadDocument = this.uploadDocument.bind(this)
    this.onProgress = this.onProgress.bind(this)
    this.complete = this.complete.bind(this)
    this.error = this.error.bind(this)
  }

  complete(fileName){
    this.setState({
      'progress': null
    })

    document.querySelectorAll('._jsLoader').forEach((domNode)=>{domNode.classList.remove('loading')})
    document.querySelectorAll('._jsLoader').forEach((domNode)=>{domNode.classList.add('complete')})

    let doc = {name: fileName}
    this.storageRef.getDownloadURL()
      .then(url => {
        doc.url = url;
        this.props.callback(doc)
      })

      setTimeout(() => 
        {
          document.querySelectorAll('._jsLoader').forEach((domNode)=>{domNode.classList.remove('complete')})
        },500)
  }
  error(err){
    console.log(err);
  }

  onProgress(snapshot){
    let percentage = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
    this.setState({
      'progress': percentage
    })
  }

  uploadDocument(file){
    const fileName = this.props.name || file.name.split('.')[0] + '-' + (+new Date());
    const ext = file.name.split('.').slice(-1)[0].toLowerCase()
    const path = this.props.path

    this.storageRef = firebaseApp.storage().ref(`${path}${fileName}.${ext}`);
    document.querySelectorAll('._jsLoader').forEach((domNode)=>{domNode.classList.add('loading')})
    // upload the doc
    const task = this.storageRef.put(file)
    task.on('state_changed', this.onProgress, this.error, () => this.complete(fileName))
  }

  render(){
    const { progress } = this.state;
    
    return (<div className="uploader" style={rootStyle}>

      { progress ? <div className="progress">
        <div className="md-caption">Uploading... </div>
        <div className="bar" style={{
            width: `${progress}%`
          }
        }>{progress}%</div>
        </div>
      : <div>
          <a href={'https://firebasestorage.googleapis.com/v0/b/specialt-a289f.appspot.com/o/documents%2Fpatient_bulk_import_template.csv?alt=media&token=e2196015-7358-4a4e-b656-7f07e6c408d4'}>
            Download Template <br/>
            <small>
              1. Download and save the above .csv Template to your chosen location.<br/>
              2. Start Excel with a blank workbook open.<br/>
              3. Select 'Data' on the ribbon, and then 'From Text'. (If the menu options are greyed out this could be because you do not have a workbook open).<br/>
              4. Browse for the *.csv file you want to open, and click 'Import/get data'.<br/>
              5. In the Text import wizard, ensure the 'Delimited' option is selected. Click Next.<br/>
              6. In the delimiters section, tick 'Comma'. The text qualifier box should show the double-quote symbol. Click Next.<br/>
              7. Mark every columns as 'Text'. The first column only will initially be highlighted. Move the horizontal cursor as far as it will go to the right; then, holding the shift key down, click the very last column heading. You should now have every column highlighted. Click the 'Text' data format. It will now say 'Text' in the header of every column. Click Finish.<br/>
              8. It may ask you 'Where do you want to put the data?'. It will allow you to click into any cell on the blank worksheet to determine where the data should go. Click 'OK' to proceed.<br/>
              9. The data should now appear in the spreadsheet. Where column headings are included these will appear in the top row. Check that fields have not lost leading zeros where applicable.<br/>
              10. When finished, save the document as a csv file.<br/>
              Required Date Format: 1 January 2018<br/>
            </small>
          </a>

          <div className="upload-button">
            <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"/>
              <path d="M0 0h24v24H0z" fill="none"/>
            </svg>

            <input  accept="text/csv" type="file" onChange={(e) => {
                this.uploadDocument(e.target.files[0], 'documents/')
              }} />
          </div>
        </div>
      }
    </div>)
  }
}

BulkImportUpload.defaultProps = {
  'name': null,
  'path': 'documents/',
  'callback': () =>{}
}

export default BulkImportUpload;



// WEBPACK FOOTER //
// ./src/components/ui/BulkImportUpload.jsx